import { makeEntityScaffold } from '@classpass/saga-tools';
import { format, parseISO } from 'date-fns';
import URLS from 'constants/urls';
import { transformKeysToCamelCase, trimTimezone } from 'helpers/core';

const formatResponseToFormDataEntityShape = response => {
  const { id, startDatetime, endDatetime, itemType, itemId, description } = response;
  const trimmedStartDatetime = trimTimezone(startDatetime);
  const trimmedEndDatetime = trimTimezone(endDatetime);

  return {
    id,
    startTime: format(parseISO(trimmedStartDatetime), 'HH:mm'),
    endTime: format(parseISO(trimmedEndDatetime), 'HH:mm'),
    date: trimmedStartDatetime,
    itemType,
    itemId,
    description,
  };
};

const get = (httpClient, venueId, botId) =>
  httpClient
    .get(URLS.blockOffTime(venueId, botId))
    .then(response => transformKeysToCamelCase(response.data))
    .then(formatResponseToFormDataEntityShape);

const handler = ({ httpClient }, venueId, botId) => get(httpClient, venueId, botId);

export default makeEntityScaffold('SAGA.API.BLOCK_OFF_TIME', handler, { defaultKey: 1 });
